import { useReadLocalStorage } from 'usehooks-ts';

import { LocalStorageService } from 'services/localStorage/localStorage';
import { UserKeys } from 'support/types/localStorage';

export const useIsPotentiallyAuthenticated = () => useReadLocalStorage(UserKeys.potentiallyAuthenticatedSession);
export const isPotentiallyAuthenticated = () => !!LocalStorageService.getItem(UserKeys.potentiallyAuthenticatedSession);

export const setPotentiallyAuthenticated = (isAuthenticated: boolean) => {
  if (!isAuthenticated) {
    LocalStorageService.removeItem(UserKeys.potentiallyAuthenticatedSession);
    window.dispatchEvent(
      new StorageEvent('storage', {
        key: UserKeys.potentiallyAuthenticatedSession,
        newValue: null,
      }),
    );
    return;
  }
  LocalStorageService.setItem(UserKeys.potentiallyAuthenticatedSession, 'true');
  window.dispatchEvent(
    new StorageEvent('storage', {
      key: UserKeys.potentiallyAuthenticatedSession,
      newValue: 'true',
    }),
  );
};
